import React from 'react';
import { Tag } from 'antd';
import {
  CheckCircleOutlined,
  WarningOutlined,
  CloseCircleOutlined
} from '@ant-design/icons';
import { HealthStatus } from './types';

interface HealthBadgeProps {
  status: HealthStatus;
  size?: 'small' | 'default' | 'large';
}

const healthConfig: Record<HealthStatus, { color: string; icon: React.ReactNode; label: string }> = {
  healthy: {
    color: 'success',
    icon: <CheckCircleOutlined />,
    label: 'Healthy'
  },
  degraded: {
    color: 'warning',
    icon: <WarningOutlined />,
    label: 'Degraded'
  },
  critical: {
    color: 'error',
    icon: <CloseCircleOutlined />,
    label: 'Critical'
  }
};

export const HealthBadge: React.FC<HealthBadgeProps> = ({ status, size = 'default' }) => {
  const config = healthConfig[status] || healthConfig.critical;

  const fontSize = size === 'large' ? '14px' : size === 'small' ? '11px' : '12px';
  const padding = size === 'large' ? '4px 12px' : size === 'small' ? '0 6px' : '2px 8px';

  return (
    <Tag
      icon={config.icon}
      color={config.color}
      style={{
        fontSize,
        padding,
        fontWeight: 500
      }}
    >
      {config.label}
    </Tag>
  );
};

export default HealthBadge;
